export default function FilterCategoryTab({value}) {
    return (
        <div className="filters-grid-category-tab">{value}</div>
    );
}